<template>
  <div class="page-header">
    <div class="header-wrapper row m-0">
      <form class="form-inline search-full col" action="#" method="get">
        <div class="form-group w-100">
          <div class="Typeahead Typeahead--twitterUsers">
            <div class="u-posRelative">
              <input class="demo-input Typeahead-input form-control-plaintext w-100" type="text"
                placeholder="Search Riho .." name="q" title="" autofocus>
              <div class="spinner-border Typeahead-spinner" role="status"><span class="sr-only">Loading... </span></div>
              <i class="close-search" data-feather="x"></i>
            </div>
            <div class="Typeahead-menu"> </div>
          </div>
        </div>
      </form>
      <div class="header-logo-wrapper col-auto p-0 col-sm-8">
        <div class="logo-wrapper"> 
            <a href="/"><img class="img-fluid for-light" src="../../assets/images/logo/logo.png" alt="logo-light">
            <img class="img-fluid for-dark" src="../../assets/images/logo/logo.png" alt="logo-dark"></a>
            </div>
                <div class="toggle-sidebar"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="feather feather-align-center status_toggle middle sidebar-toggle">
                    <line x1="18" y1="10" x2="6" y2="10"></line>
                    <line x1="21" y1="6" x2="3" y2="6"></line>
                    <line x1="21" y1="14" x2="3" y2="14"></line>
                    <line x1="18" y1="18" x2="6" y2="18"></line>
                  </svg>
                   <img class="img-fluid for-light" src="../../assets/images/logo/logo_dark.png" alt="logo-light" style="width: 120px;">
                   </div>
             </div>
      
      <div class="left-header col-xxl-5 col-xl-6 col-lg-5 col-md-4 col-sm-8 p-0">
        <div> <a class="toggle-sidebar" href="#"> <i class="iconly-Category icli"> </i></a>
        
          <div class="d-flex align-items-center gap-2 ">
            <h4 class="f-w-600">Hello {{ emp.empname }}</h4><img class="mt-0" src="../../assets/images/hand.gif"
              alt="hand-gif">
          </div>
        </div>
        <div class="welcome-content d-xl-block d-none"><span class="text-truncate col-12">We Wishes You Have a Nice Day. </span></div>
      </div>
      <div class="nav-right col-xxl-7 col-xl-6 col-md-7 col-4 pull-right right-header p-0 ms-auto">
        <ul class="nav-menus">
          <li class="d-md-block d-none">
            <!-- <div class="form search-form mb-0">
              <div class="input-group"><span class="input-icon">
                  <svg>
                    <use href="../../assets/svg/icon-sprite.svg#search-header"></use>
                  </svg>
                  <input class="w-100" type="search" placeholder="Search"></span></div>
            </div> -->
          </li>
          <!-- <li class="d-md-none d-block">
            <div class="form search-form mb-0">
              <div class="input-group"> <span class="input-show">
                  <svg id="searchIcon">
                    <use href="../../assets/svg/icon-sprite.svg#search-header"></use>
                  </svg>
                  <div id="searchInput">
                    <input type="search" placeholder="Search">
                  </div>
                </span></div>
            </div>
          </li> -->

          <!-- 
          
          <li class="onhover-dropdown">
            <svg>
              <use href="../../assets/svg/icon-sprite.svg#star"></use>
            </svg>
            <div class="onhover-show-div bookmark-flip">
              <div class="flip-card">
                <div class="flip-card-inner">
                  <div class="front">
                    <h6 class="f-18 mb-0 dropdown-title">Bookmark</h6>
                    <ul class="bookmark-dropdown">
                      <li>
                        <div class="row">
                          <div class="col-4 text-center">
                            <div class="bookmark-content">
                              <div class="bookmark-icon"><i data-feather="file-text"></i></div><span>Forms</span>
                            </div>
                          </div>
                          <div class="col-4 text-center">
                            <div class="bookmark-content">
                              <div class="bookmark-icon"><i data-feather="user"></i></div><span>Profile</span>
                            </div>
                          </div>
                          <div class="col-4 text-center">
                            <div class="bookmark-content">
                              <div class="bookmark-icon"><i data-feather="server"></i></div><span>Tables</span>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="text-center"><a class="flip-btn f-w-700" id="flip-btn" href="javascript:void(0)">Add
                          New Bookmark</a></li>
                    </ul>
                  </div>
                  <div class="back">
                    <ul>
                      <li>
                        <div class="bookmark-dropdown flip-back-content">
                          <input type="text" placeholder="search...">
                        </div>
                      </li>
                      <li><a class="f-w-700 d-block flip-back" id="flip-back" href="javascript:void(0)">Back</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </li> -->





          <!-- <li>
            <div class="mode"><i class="moon" data-feather="moon"> </i></div>
          </li> -->


          <li class="onhover-dropdown notification-down">
            <div class="notification-box">
              <svg>
                <use href="../../assets/svg/icon-sprite.svg#notification-header"></use>
              </svg><span class="badge rounded-pill badge-secondary">{{ notifications.length || 0 }} </span>
            </div>
            <div class="onhover-show-div notification-dropdown">
              <div class="card mb-0">
                <div class="card-header">
                  <div class="common-space">
                    <h4 class="text-start f-w-600">Notifications</h4>
                    <div><span>{{ notifications.length }} New</span></div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="notitications-bar">
                    <ul class="nav nav-pills nav-primary p-0" id="pills-tab" role="tablist">
                      <!--<li class="nav-item p-0">-->
                      <!--  <a class="nav-link" :class="{ active: activeTab === 'all' }" id="pills-aboutus-tab"-->
                      <!--    @click="setActiveTab('all')" href="#pills-aboutus" role="tab" aria-controls="pills-aboutus"-->
                      <!--    aria-selected="true">-->
                      <!--    All({{ notifications.length }})-->
                      <!--  </a>-->
                      <!--</li>-->
                      <!-- <li class="nav-item p-0">
                        <a class="nav-link" :class="{ active: activeTab === 'employee' }" id="pills-employees-tab"
                          @click="setActiveTab('employee')" href="#pills-employees" role="tab"
                          aria-controls="pills-employees" aria-selected="false">
                          Employee
                        </a>
                      </li> -->
                      <!-- <li class="nav-item p-0">
                        <a class="nav-link" :class="{ active: activeTab === 'visitor' }" id="pills-visitor-tab"
                          @click="setActiveTab('visitor')" href="#pills-visitor" role="tab"
                          aria-controls="pills-visitor" aria-selected="false">
                          Visitor
                        </a>
                      </li> -->
                    </ul>
                    <div class="tab-content" id="pills-tabContent">
                      <div class="tab-pane fade" :class="{ 'show active': activeTab === 'all' }" id="pills-aboutus"
                        role="tabpanel" aria-labelledby="pills-aboutus-tab">
                        <div class="user-message" v-if="notifications.length > 0">
                          <ul>
                            <li v-for="(notification, index) in notifications" :key="index">
                              <div class="user-alerts">
                                

                                  <div class="f-light f-w-500 f-12 text-danger"@click="markread(notification)" >{{ notification.content}}
                                  <span class="f-light">{{notification.iddate}}</span>
                                  </div>
                                    
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div v-else class="text-center py-3">
                          <p>No notifications available</p>
                        </div>
                      </div>
                      <!-- Employee notification section with contact instead of gatepass ID -->
                      <!--<div class="tab-pane fade" :class="{ 'show active': activeTab === 'employee' }"-->
                      <!--  id="pills-employees" role="tabpanel" aria-labelledby="pills-employees-tab">-->
                      <!--  <div class="user-message" v-if="employeeNotifications.length > 0">-->
                      <!--    <ul>-->
                      <!--      <li v-for="(notification, index) in employeeNotifications" :key="index">-->
                      <!--        <div class="user-alerts">-->
                      <!--          <div-->
                      <!--            class="user-image rounded-circle img-fluid me-2 d-flex align-items-center justify-content-center bg-primary text-white"-->
                      <!--            style="width: 40px; height: 40px; font-size: 16px;">-->
                      <!--            {{ notification.employee_name ? notification.employee_name.charAt(0).toUpperCase() :-->
                      <!--              'U' }}-->
                      <!--          </div>-->
                      <!--          <div class="user-name">-->
                      <!--            <div>-->
                      <!--              <h6><a class="f-w-500 f-14" href="../template/user-profile.html">{{-->
                      <!--                notification.employee_name }}</a></h6>-->
                      <!--              <span class="f-light f-w-500 f-12">Contact: {{ notification.employee_contact ||-->
                      <!--                'N/A' }}</span>-->
                      <!--            </div>-->
                      <!--            <div>-->
                      <!--              <svg>-->
                      <!--                <use href="../../assets/svg/icon-sprite.svg#more-vertical"></use>-->
                      <!--              </svg>-->
                      <!--            </div>-->
                      <!--          </div>-->
                      <!--        </div>-->
                      <!--      </li>-->
                      <!--    </ul>-->
                      <!--  </div>-->
                      <!--  <div v-else class="text-center py-3">-->
                      <!--    <p>No employee notifications</p>-->
                      <!--  </div>-->
                      <!--</div>-->
                      <!-- Visitor notification section with images -->
                      <!--<div class="tab-pane fade" :class="{ 'show active': activeTab === 'visitor' }" id="pills-visitor"-->
                      <!--  role="tabpanel" aria-labelledby="pills-visitor-tab">-->
                      <!--  <div class="user-message" v-if="visitorNotifications.length > 0">-->
                      <!--    <ul>-->
                      <!--      <li v-for="(notification, index) in visitorNotifications" :key="index">-->
                      <!--        <div class="user-alerts">-->
                                <!-- Add visitor image if available, otherwise use initials -->
                      <!--          <div v-if="notification.visitor_image" class="user-image me-2"-->
                      <!--            style="width: 40px; height: 40px;">-->
                      <!--            <img class="rounded-circle img-fluid"-->
                      <!--              :src="getVisitorImagePath(notification.visitor_image)" alt="Visitor Image"-->
                      <!--              style="width: 100%; height: 100%; object-fit: cover;">-->
                      <!--          </div>-->
                      <!--          <div v-else-->
                      <!--            class="user-image rounded-circle img-fluid me-2 d-flex align-items-center justify-content-center bg-secondary text-white"-->
                      <!--            style="width: 40px; height: 40px; font-size: 16px;">-->
                      <!--            {{ notification.visitor_name ? notification.visitor_name.charAt(0).toUpperCase() : 'V'-->
                      <!--            }}-->
                      <!--          </div>-->
                      <!--          <div class="user-name">-->
                      <!--            <div>-->
                      <!--              <h6><a class="f-w-500 f-14" href="../template/user-profile.html">{{-->
                      <!--                notification.visitor_name || 'Visitor' }}</a></h6>-->
                      <!--              <span class="f-light f-w-500 f-12">{{ notification.visitor_contact ||-->
                      <!--                notification.visitor_firm || 'Visitor' }}</span>-->
                      <!--            </div>-->
                      <!--            <div>-->
                      <!--              <svg>-->
                      <!--                <use href="../../assets/svg/icon-sprite.svg#more-vertical"></use>-->
                      <!--              </svg>-->
                      <!--            </div>-->
                      <!--          </div>-->
                      <!--        </div>-->
                      <!--      </li>-->
                      <!--    </ul>-->
                      <!--  </div>-->
                      <!--  <div v-else class="text-center py-3">-->
                      <!--    <p>No visitor notifications</p>-->
                      <!--  </div>-->
                      <!--</div>-->
                      <!--<div class="card-footer pb-0 pr-0 pl-0">-->
                      <!--  <div class="text-center">-->
                      <!--    <a class="f-w-700" href="javascript:void(0)" @click="checkAllNotifications">-->
                      <!--      <button class="btn btn-primary" type="button" title="btn btn-primary">Check all</button>-->
                      <!--    </a>-->
                      <!--  </div>-->
                      <!--</div>-->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li class="profile-nav onhover-dropdown">
            <div class="media profile-media"><img class="b-r-10" :src="this.$hostname+'index.php/visitor-image/user.png'" alt="" style="height: 40px;" width="40px">
              <div class="media-body d-xxl-block d-none box-col-none">
                <div class="d-flex align-items-center gap-2"> <span>{{ emp.empname }} </span><i
                    class="middle fa fa-angle-down"> </i></div>
                <p class="mb-0 font-roboto" v-if="emp.emprole == 1">ADMIN</p>
                <p class="mb-0 font-roboto" v-else-if="emp.emprole == 2">HOD</p>
                <p class="mb-0 font-roboto" v-else-if="emp.emprole == 3">Employee</p>
              </div>
            </div>
            <ul class="profile-dropdown onhover-show-div">
              <li><router-link to="/profile"><i data-feather="user"></i><span>{{ emp.empname }}</span></router-link></li>

              <li><a class="btn btn-pill btn-outline-primary btn-sm" @click="logout()">Log Out</a></li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <!-- Page Sidebar Start-->
  <div class="sidebar-wrapper" ref="sidebar" data-layout="stroke-svg">
    <div class="logo-wrapper"> <img class="img-fluid" src="../../assets/images/logo/logo.png" alt=""> 
      <div class="back-btn"><i class="fa fa-angle-left"> </i></div>
      <div class="toggle-sidebar" @click="sidebar_btn" checked="checked"><svg xmlns="http://www.w3.org/2000/svg"
          width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round"
          class="feather feather-grid status_toggle middle sidebar-toggle">
          <rect x="3" y="3" width="7" height="7"></rect>
          <rect x="14" y="3" width="7" height="7"></rect>
          <rect x="14" y="14" width="7" height="7"></rect>
          <rect x="3" y="14" width="7" height="7"></rect>
        </svg></div>
    </div>
    <div class="logo-icon-wrapper"><a href="/">
        <img class="img-fluid" src="../../assets/images/logo/logo_sm.png" style="width:40px"
          alt=""></a></div>
    <nav class="sidebar-main">
      <div class="left-arrow" id="left-arrow"><i data-feather="arrow-left"></i></div>
      <div id="sidebar-menu">
        <ul class="sidebar-links" id="simple-bar" data-simplebar="init" style="display: block;">
          <div class="simplebar-wrapper" style="margin: 0px;">
            <div class="simplebar-height-auto-observer-wrapper">
              <div class="simplebar-height-auto-observer"></div>
            </div>
            <div class="simplebar-mask">
              <div class="simplebar-offset" style="right: 0px; bottom: 0px;">
                <div class="simplebar-content-wrapper" style="height: 100%; overflow: hidden scroll;">
                  <div class="simplebar-content" style="padding: 0px;">
                    <li class="back-btn"><a href="/"><img class="img-fluid" src="../../assets/images/logo/logo-icon.png"
                          alt=""></a>
                      <div class="mobile-back text-end"> <span>Back </span><i class="fa fa-angle-right ps-2"
                          aria-hidden="true"></i></div>
                    </li>
                    <li class="pin-title sidebar-main-title">
                      <div>
                        <h6>Pinned</h6>
                      </div>
                    </li>
                    <li class="sidebar-main-title">
                      <div>
                        <h6 class="lan-1">General</h6>
                      </div>
                    </li>
                    <li  @click="MobileBackBtn"  class="sidebar-list"><i class="fa fa-thumb-tack"></i>
                      <router-link class="sidebar-link sidebar-title link-nav" to="/dashboard">
                        <svg class="stroke-icon">
                          <use href="../../assets/svg/icon-sprite.svg#stroke-file"></use>
                        </svg>
                        <svg class="fill-icon">
                          <use href="../../assets/svg/icon-sprite.svg#fill-file"></use>
                        </svg><span>Dashboard</span>
                        <div class="according-menu"><i class="fa fa-angle-right"></i></div>
                      </router-link>
                    </li>
                    

                    <li @click="MobileBackBtn" class="sidebar-list"  v-if="emp.empdept == sd"><i class="fa fa-thumb-tack"></i>
                      <router-link class="sidebar-link sidebar-title link-nav" to="/securitydashboard">
                        <svg class="stroke-icon">
                          <use href="../../assets/svg/icon-sprite.svg#advance"></use>
                        </svg>
                        <svg class="fill-icon">
                          <use href="../../assets/svg/icon-sprite.svg#fill-file"></use>
                        </svg><span>Security Dashboard</span>
                        <div class="according-menu"><i class="fa fa-angle-right"></i></div>
                      </router-link>
                    </li>






                    <li class="sidebar-list "  @click="MobileBackBtn" v-if="emp.empdept == sd" ><i class="fa fa-thumb-tack"></i>
                      <router-link class="sidebar-link sidebar-title link-nav" to="/SecurityTab">
                        <svg class="stroke-icon">
                          <use href="../../assets/svg/icon-sprite.svg#new-order"></use>
                        </svg>
                        <svg class="fill-icon">
                          <use href="../../assets/svg/icon-sprite.svg#fill-file"></use>
                        </svg><span>Tab Screen </span>
                        <div class="according-menu"><i class="fa fa-angle-right"></i></div>
                      </router-link>
                    </li>







                    <li class="sidebar-list" v-show="emp.emprole == 1"><i class="fa fa-thumb-tack"> </i><a class="sidebar-link sidebar-title"
                        href="#">
                        <svg class="stroke-icon">
                          <use href="../../assets/svg/icon-sprite.svg#star"></use>
                        </svg>
                        <svg class="fill-icon">
                          <use href="../../assets/svg/icon-sprite.svg#fill-home"></use>
                        </svg><span class="lan-3">Master</span>
                        <div class="according-menu"><i class="fa fa-angle-right"></i></div>
                      </a>
                      <ul class="sidebar-submenu" style="display: none;">
                        <li ><router-link to="/departments" @click="MobileBackBtn">Departments</router-link></li>
                        <li ><router-link to="/users" @click="MobileBackBtn">Users</router-link></li>
                        <li ><router-link to="/rooms" @click="MobileBackBtn">Meeting Rooms</router-link></li>
                        <li ><router-link to="/vehicles" @click="MobileBackBtn">Vehicles</router-link></li>
                        <li ><router-link to="/documents" @click="MobileBackBtn">documents</router-link></li>
                      </ul>
                    </li>

                    <!--<li class="sidebar-list"  v-if="emp.emprole == 1"><i class="fa fa-thumb-tack"> </i><a class="sidebar-link sidebar-title"-->
                    <!--    href="#">-->
                    <!--    <svg class="stroke-icon">-->
                    <!--      <use href="../../assets/svg/icon-sprite.svg#star"></use>-->
                    <!--    </svg>-->
                    <!--    <svg class="fill-icon">-->
                    <!--      <use href="../../assets/svg/icon-sprite.svg#fill-home"></use>-->
                    <!--    </svg><span class="lan-3">Master</span>-->
                    <!--    <div class="according-menu"><i class="fa fa-angle-right"></i></div>-->
                    <!--  </a>-->
                    <!--  <ul class="sidebar-submenu" style="display: none;">-->
                    <!--    <li ><router-link to="/departments" @click="MobileBackBtn">Departments</router-link></li>-->
                    <!--    <li ><router-link to="/users" @click="MobileBackBtn">Users</router-link></li>-->
                    <!--    <li ><router-link to="/rooms" @click="MobileBackBtn">Meeting Rooms</router-link></li>-->
                    <!--    <li ><router-link to="/vehicles" @click="MobileBackBtn">Vehicles</router-link></li>-->
                    <!--    <li ><router-link to="/documents" @click="MobileBackBtn">documents</router-link></li>-->
                    <!--  </ul>-->
                    <!--</li>-->

                          













                    <li class="sidebar-list"><i class="fa fa-thumb-tack"> </i><a class="sidebar-link sidebar-title"
                        href="#">
                        <svg class="stroke-icon">
                          <use href="../../assets/svg/icon-sprite.svg#orders"></use>
                        </svg>
                        <svg class="fill-icon">
                          <use href="../../assets/svg/icon-sprite.svg#fill-home"></use>
                        </svg><span class="lan-3">Gatepass</span>
                        <div class="according-menu"><i class="fa fa-angle-right"></i></div>
                      </a>
                      <ul class="sidebar-submenu" style="display: none;">
                        <li ><router-link to="/gatepass"  @click="MobileBackBtn" >Visitor</router-link></li>
                        <li ><router-link to="/createEmployeeGatepass"  @click="MobileBackBtn" >Employee</router-link></li>
                        <li ><router-link to="/securitygatepass"  v-if="emp.empdept == sd"  @click="MobileBackBtn" >Security Gatepass</router-link></li>
                      </ul>
                    </li>











                  <li class="sidebar-list "  @click="MobileBackBtn"  v-if="emp.empdept == sd"><i class="fa fa-thumb-tack"></i>
                    <router-link class="sidebar-link sidebar-title link-nav" to="/workpermit">
                      <svg class="stroke-icon">
                        <use href="../../assets/svg/icon-sprite.svg#new-order"></use>
                      </svg>
                      <svg class="fill-icon">
                        <use href="../../assets/svg/icon-sprite.svg#fill-file"></use>
                      </svg><span>Work Permit</span>
                      <div class="according-menu"><i class="fa fa-angle-right"></i></div>
                    </router-link>
                  </li>









                    <li class="sidebar-list"><i class="fa fa-thumb-tack"> </i><a class="sidebar-link sidebar-title"
                        href="#">
                        <svg class="stroke-icon">
                          <use href="../../assets/svg/icon-sprite.svg#clock"></use>
                        </svg>
                        <svg class="fill-icon">
                          <use href="../../assets/svg/icon-sprite.svg#fill-home"></use>
                        </svg><span class="lan-3">Room Reservation</span>
                        <div class="according-menu"><i class="fa fa-angle-right"></i></div>
                      </a>
                      <ul class="sidebar-submenu" style="display: none;">
                        <li ><router-link to="/meetingroombook"  @click="MobileBackBtn" >Reservation</router-link></li>
                        <li ><router-link to="/calender"  @click="MobileBackBtn" >Calender</router-link></li>
                      </ul>
                    </li>


                    <li class="sidebar-list "  @click="MobileBackBtn" ><i class="fa fa-thumb-tack"></i>
                      <router-link class="sidebar-link sidebar-title link-nav" to="/vehicalrequest">
                        <svg class="stroke-icon">
                          <use href="../../assets/svg/icon-sprite.svg#new-order"></use>
                        </svg>
                        <svg class="fill-icon">
                          <use href="../../assets/svg/icon-sprite.svg#fill-file"></use>
                        </svg><span>Vehicle Request</span>
                        <div class="according-menu"><i class="fa fa-angle-right"></i></div>
                      </router-link>
                    </li>
                    


                  <!--<li class="sidebar-list "  @click="MobileBackBtn" v-if="emp.empdept == sd || emp.emprole == 1" ><i class="fa fa-thumb-tack"></i>-->
                  <li class="sidebar-list "  @click="MobileBackBtn"  ><i class="fa fa-thumb-tack"></i>
                    <router-link class="sidebar-link sidebar-title link-nav" to="/visitorlist">
                      <svg class="stroke-icon">
                        <use href="../../assets/svg/icon-sprite.svg#user-visitor"></use>
                      </svg>
                      <svg class="fill-icon">
                        <use href="../../assets/svg/icon-sprite.svg#user-visitor"></use>
                      </svg><span>Visitor List</span>
                      <div class="according-menu"><i class="fa fa-angle-right"></i></div>
                    </router-link>
                  </li>





                    <!--<li class="sidebar-list "  v-if="emp.empdept == sd"><i class="fa fa-thumb-tack"></i>-->
                    <!--  <router-link class="sidebar-link sidebar-title link-nav" to="/securitydashboard">-->
                    <!--    <svg class="stroke-icon">-->
                    <!--      <use href="../../assets/svg/icon-sprite.svg#advance"></use>-->
                    <!--    </svg>-->
                    <!--    <svg class="fill-icon" >-->
                    <!--      <use href="../../assets/svg/icon-sprite.svg#fill-file"></use>-->
                    <!--    </svg><span>Security Dashboard</span>-->
                    <!--    <div class="according-menu"><i class="fa fa-angle-right"></i></div>-->
                    <!--  </router-link>-->
                    <!--</li>-->
                  </div>
                </div>
              </div>
            </div>
            <div class="simplebar-placeholder" style="width: auto; height: 2055px;"></div>
          </div>
        </ul>
        <div class="right-arrow" id="right-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" class="feather feather-arrow-right">
            <line x1="5" y1="12" x2="19" y2="12"></line>
            <polyline points="12 5 19 12 12 19"></polyline>
          </svg></div>
      </div>
    </nav>
  </div>
</template>

<style lang="scss">
@import "../../assets/scss/utils/_variables.scss";  
@import "../../assets/scss/components/_scrollbar.scss"; </style>

<style>
.simplebar-wrapper {
  overflow-y: hidden;
  overflow-x: hidden;
}

.simplebar-mask {
  top: 0;
}
.page-wrapper .page-header .header-wrapper .nav-right .onhover-show-div .notitications-bar .user-message ul li{
        padding: 5px 5px !important;
                border-bottom: 1px solid #d4d4d4;
}
</style>

<script>

// import axios from 'axios';
import axios from "@/plugins/axios";
import { nextTick } from 'vue';
export default {
  name: 'Header',
  
 mounted() {
    
     this.checkQueryParam();
    // document.addEventListener('mousedown', this.handleClickOutside);
    //   console.log(this.$route.query.q);
    // if(this.$route.query.q){
    //     if (localStorage['_emp_token']) {
    //         // console.log("Last employee found");
    //       this.getUserDetails();
    //     } else if (localStorage['token']) {
    //         console.log("Last employee not found");
    //       this.$router.push({ name: "visitorpage" });
    //     }
    // }
    //  else if (this.$route.path == '/login') {  // Added leading slash
    //     // Don't redirect if we're already on login page
    //     return;
    // } else {
    //     this.$router.push({ name: "register" });
    // }
  
},
watch: {
    '$route.query.q'() {
      this.checkQueryParam();
    }
  },
  data() {
    return {
      emp: { name: '', dept: '', empcode: '', role: '' },
      otp: '',
      sidebar_status: true,
      notifications: [],
      employeeNotifications:[],
      visitorNotifications:[],
      activeTab: 'all',
      sd:0,
      passid:null,
      notificationfuserid:null,
        }
  },
  computed: {
    // employeeNotifications() {
    //   return this.notifications.filter(notification =>
    //     notification.employee_name && notification.employee_name.trim() !== '');
    // },
    // visitorNotifications() {
    //   return this.notifications.filter(notification =>
    //     !notification.employee_name ||
    //     notification.employee_name.trim() === '' ||
    //     notification.visitor_name);
    // }
  },
  methods: {
       handleClickOutside(event) {
              const sidebar = this.$refs.sidebar;
              if (sidebar && !sidebar.contains(event.target)) {
                this.MobileBackBtn();
              }
            }
            ,
      checkQueryParam() {
      const q = this.$route.query.q;
      if (!q) {
        if (localStorage['_emp_token']) {
          this.getUserDetails();
        } else if (localStorage['token']) {
          this.$router.push({ name: "visitorpage" });
        }
      }
    },
    
    sidebar_btn() {
      this.sidebar_status = !this.sidebar_status;
      if (this.sidebar_status)
        $("#pageWrapper").toggleClass("sidebar_closed");
      else
        $("#pageWrapper").addClass("sidebar_closed");
    },
    logout() {
      localStorage.removeItem('token');
      localStorage.removeItem('_emp_token');
      window.location.href = this.$cur_host + 'login';
    },
    getVisitorImagePath(imageName) {
      if (!imageName) return null;
      // Use the correct path based on your application structure
      return `/assets/images/visitors/${imageName}`;
    },
    getUserDetails() {
      const self = this;

      if (localStorage['_emp_token']) {
        axios.post('getEmpDetails', { token: localStorage['_emp_token'] })
          .then(function (response) {
            if (response.data.is === 1) {
                self.emp = response.data.emp;

                self.notifications = response.data.Notifications;
               // console.log(Notifications);
                self.sd=response.data.sd;
                if(self.$route.name=='' || self.$route.name==undefined || self.$route.name=='login'){
                    if(localStorage['security']=='1'){
                        self.$router.push({ name: "securitydashboard" }); 
                    }
                    else
                        self.$router.push({ name: "dashboard" });
                }
            } else {
              localStorage.removeItem('_emp_token');
              self.$swal("Session Expired, Please Login");
              self.$router.push({ name: "login" });
            }
          })
          .catch(function (error) {
            console.error('Error fetching user details:', error);
            self.$router.push({ name: "login" });
          });
      }
    },

   MobileBackBtn() {
      if (window.innerWidth <= 768) {
        const backBtn = document.querySelector(".back-btn");
        if (backBtn) {
          backBtn.click();
        } else {
          console.warn("No .back-btn element found.");
        }
      }
    },

        markread(notification) {
        //   this.passid=notification.gatepassid;
        //   this.notificationfuserid=notification.notifuserid;
          var self = this;
    //   .id,notification.gatepassid,notification.foruserid
    if(notification?.employeeid=="0")
            self.$router.push({ name: 'gatepass', query: { visitorid: notification.visitorid } }); 
    else if(notification?.vehicalreqid!="0")
            self.$router.push({ name: 'vehicalrequest', query: { visitorid: notification.vehicalreqid } }); 
    else
            self.$router.push({ name: 'createEmployeeGatepass', query: { visitorid: notification.employeeid } });
            
        //  self.$router.push({ name: 'createEmployeeGatepass?visitorid='+notification.visitorid });
      
        // self.$swal({
        //     title: "Are you sure you want to mark this as read?",
        //     // text: "This action will update the status to read.",
        //     icon: "warning", // Use 'icon' instead of deprecated 'type'
        //     showCancelButton: true,
        //     confirmButtonColor: "#3085d6",
        //     confirmButtonText: "Yes, mark as read!"
        // }).then((result) => {
        //     if (result.isConfirmed) { // 'isConfirmed' is the proper way in newer SweetAlert2
        //         axios.post('allmarkread', { id: id }).then(function (response) {
        //             self.gatepass = response.data.gatepass;

        //              if(self.passid>0){
        //               self.gatepass = response.data.gatepass;
        //               self.$router.push({ name: 'gatepass' });
        //              }

        //         });
        //     }
        // });


    // if (self.notificationfuserid == 1000){
    //       self.$swal("Clicked");
    // }
    // else{


    //     axios.post('allmarkread', { id: id }).then(function (response) {
    //           self.gatepass = response.data.gatepass;
    //           self.notifications = response.data.Notifications;

    //           if (self.passid > 0) {
    //               self.gatepass = response.data.gatepass;
    //               self.notifications = response.data.Notifications;
    //               self.$router.push({ name: 'gatepass' });
    //           }
    //       });

    //     }



    },











 
  }
}
</script>